import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import { SummaryView } from './summary-view';

const inContextVersion = '1.1';

export class InlineRecommendationCardView extends Backbone.View {
  constructor(options) {
    super(options);
    this.options = _.defaults(options, {
      viewSummary: _.noop,
    });
    this.isShowCard = this.options.isShowCard;
  }

  render() {
    const context = {
      Level: this.options.scope.levelAt,
      CampaignIds: this.options.scope.campaignId ? [Number(this.options.scope.campaignId)] : [],
      AdGroupIds: this.options.scope.adGroupId ? [Number(this.options.scope.adGroupId)] : [],
      'ITC-Version': inContextVersion,
    };

    ReactDOM.render(<SummaryView
      {...this.options}
      isInlineView
      el={this.options.containerEl}
      context={context}
    />, this.el);
    if (!this.isShowCard) {
      this.$el.hide();
    }
    return this;
  }

  toggleView() {
    this.isShowCard = !this.isShowCard;
    if (this.isShowCard) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
